import { readReducedMotionPreference } from "../utils/reducedMotionPreference";

export type CameraAutofocusMode = "center" | "fit";
export type CameraMotionMode = "smooth" | "jump";

export type CameraViewPreferences = {
  autofocusMode: CameraAutofocusMode;
  motionMode: CameraMotionMode;
};

export const CAMERA_VIEW_SETTINGS_KEY = "critter.cameraViewMenuSettings";
export const CAMERA_VIEW_SMOOTH_DURATION_MS = 300;

const DEFAULT_CAMERA_VIEW_PREFERENCES: CameraViewPreferences = {
  autofocusMode: "fit",
  motionMode: "smooth",
};

export function readCameraViewPreferences(): CameraViewPreferences {
  if (typeof window === "undefined") return DEFAULT_CAMERA_VIEW_PREFERENCES;

  try {
    const parsed = JSON.parse(window.localStorage.getItem(CAMERA_VIEW_SETTINGS_KEY) || "{}");
    return {
      autofocusMode: parsed.autofocusMode === "center" ? "center" : "fit",
      motionMode: readReducedMotionPreference()
        ? "jump"
        : parsed.motionMode === "jump"
          ? "jump"
          : "smooth",
    };
  } catch {
    return {
      ...DEFAULT_CAMERA_VIEW_PREFERENCES,
      motionMode: readReducedMotionPreference()
        ? "jump"
        : DEFAULT_CAMERA_VIEW_PREFERENCES.motionMode,
    };
  }
}

export function getCameraViewAutofocusOptions() {
  const preferences = readCameraViewPreferences();
  return {
    framing: preferences.autofocusMode === "center" ? "recenter" : "fit",
    durationMs: preferences.motionMode === "jump" ? 0 : CAMERA_VIEW_SMOOTH_DURATION_MS,
  } as const;
}
